import template from './employeeAfk.html';
import controller from './employeeAfk.controller';
import './employeeAfk.scss';

let employeeAfkComponent = {
  restrict: 'E',
  bindings: {
    userId: '@',
    hasDelegated: '<',
    delegation: '<',
    sendIncept: '&',
    isDisabled: '<'
  },
  template,
  controller,
};

export default employeeAfkComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/employeeAfk/employeeAfk.component.js